export default function () {
  $('.ref-accordion-item  .content').each(function () {
    const that = $(this);
    const height = that.height() + 36;
    that.css('height', height);
    that.css('transition-duration', `${0.08 + height / 1000}s`);
    that.parent().parent().addClass('hide');
  });

  $('.ref-accordion-item').on('click', function () {
    $(this).toggleClass('hide');
  });
}
